<template>
    <div class="page" @touchmove.prevent>
        <div :class="['pop-header', switch3DCat ? 'header-3d' : 'header-2d']">
            <div class="pop-title">恭喜你</div>
            <div class="pop-desc">成长权益已升级至{{ updateInfo.currentLevel }}</div>
        </div>
        <div class="popUp">
            <div class="lock-grade">
                <div class="lock-title">
                    <div class="sep-line"></div>
                    <div>您新解锁了以下权益</div>
                    <div class="sep-line"></div>
                </div>
                <div
                    v-if="updateInfo && updateInfo.unlockBenefit"
                    :class="[
                        'grade-area',
                        updateInfo && updateInfo.unlockBenefit.length > 3
                            ? 'grade-area-star'
                            : 'grade-area-center',
                    ]"
                >
                    <div
                        class="grade-item"
                        v-for="(item, index) in updateInfo.unlockBenefit"
                        :key="index"
                    >
                        <div
                            class="grade-icon"
                            :style="{ backgroundImage: `url(${item.icon})` }"
                        ></div>
                        <div class="grade-title">{{ item.title }}</div>
                        <div class="grade-desc">{{ item.desc }}</div>
                    </div>

                    <div
                        v-if="updateInfo.nextLockBenefit.differenceOfNextLockScore > 0"
                        class="lock-alert"
                    >
                        再获得{{
                            updateInfo.nextLockBenefit.differenceOfNextLockScore
                        }}活力值可解锁<span style="color: #ff8143; font-weight: bold"
                            >{{ updateInfo.nextLockBenefit.nextLockBenefitNum }}项</span
                        >新权益
                    </div>
                    <div class="pop-butn" @click="clickGrade"></div>
                </div>
            </div>
        </div>
        <div @click="confirm" class="popup-close"></div>
    </div>
</template>

<script>
export default {
    props: ['score', 'updateInfo', 'switch3DCat'],
    created() {
        this.POINT('h5_element_imp', {
            page: 'super-成长权益页',
            tgt_event_id: 'h5_ACT_privilege_box',
            tgt_name: 'h5-ACT-成长权益-弹窗',
            param: this.score,
            param1: '升级弹窗'
        });
    },
    methods: {
        clickGrade() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_privilege_box',
                tgt_name: 'h5-ACT-成长权益-弹窗',
                param: this.score,
                param1: '升级弹窗',
                param2: '我知道了'
            });
            this.$emit('onOpen');
        },
        confirm() {
            this.$emit('onOpen');
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
.page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .header-3d {
        height: 131px;
        background-image: url('@{asserts}/popup-head-3d@2x.png');
    }
    .header-2d {
        height: 70px;
        background-image: url('@{asserts}/popup-head@2x.png');
    }
    .pop-header {
        width: 320px;
        background-size: 100% 100%;
        color: #ffb900;
        text-align: center;
        .pop-title {
            font-weight: bold;
            margin-top: 8px;
            font-size: 22px;
        }
        .pop-desc {
            font-weight: bold;
            margin-top: 7px;
            font-size: 22px;
        }
    }
    .popUp {
        width: 320px;
        height: auto;
        background-color: #fff;
        border-radius: 12px;
        border: 4px solid #ffb483;
        .lock-grade {
            margin-top: 17px;
            .lock-title {
                color: #855749;
                font-size: 14px;
                font-weight: bold;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                .sep-line {
                    margin: 0 8px;
                    width: 25px;
                    height: 1px;
                    background-color: #b0968e;
                }
            }
        }
        .grade-area-star {
            justify-content: flex-start;
        }
        .grade-area-center {
            justify-content: center;
        }
        .grade-area {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            margin-top: 20px;
            padding: 0 6px;
            .grade-item {
                width: 75px;
                height: 80px;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #855749;
                font-size: 12px;
                // font-family: fzlt_bold;
                font-weight: bold;
                .grade-icon {
                    width: 38px;
                    height: 38px;
                    background-size: 100% 100%;
                }
                .grade-title {
                    margin-top: 6px;
                }
                .grade-desc {
                    margin-top: 4px;
                }
            }
            .lock-alert {
                margin-top: 25px;
                color: #855749;
                font-size: 12px;
                // font-family: fzlt;
                text-align: center;
                width: 100%;
            }
            .pop-butn {
                position: relative;
                margin: 0 32px 12px;
                top: 9px;
                width: 245px;
                height: 59px;
                background-image: url('@{asserts}/popup-buntn@2x.png');
                background-size: 100% 100%;
            }
        }
    }
    .popup-close {
        margin-top: 26px;
        width: 32px;
        height: 32px;
        background-image: url('@{asserts}/popup-close@2x.png');
        background-size: 100% 100%;
    }
}
</style>